import { useEffect, useState } from "react";
import React from "react";
import TestComponent from './testComponent'

const FactsPDF = (props) => {
  const [base64PDF, setBase64PDF] = useState("");

  useEffect(() => {
    setBase64PDF(props?.data)
  }, [props?.data]);

  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      <iframe
        src={`data:application/pdf;base64,${base64PDF}`}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          border: "none", // Optional, to remove the iframe border
        }}
        title="PDF Viewer"
      />
    </div>
  );
};

export default FactsPDF;
